export function StudentDashboard() {
  return (
    <div className="stack">
      <div><h1>Halo, Andi 👋</h1><p className="muted">Belajar Hari Ini</p></div>
      <section className="grid grid--3">
        <div className="metric"><span>Matematika</span><strong>3</strong><span className="muted">worksheet</span></div>
        <div className="metric"><span>English</span><strong>2</strong><span className="muted">worksheet</span></div>
        <div className="metric"><span>Listening</span><strong>5</strong><span className="muted">audio</span></div>
      </section>
      <section className="card"><h2>PR berikutnya</h2><p>Matematika · Level C · MTH-C-ADD-031</p><button className="btn btn--primary" type="button">Lihat PR</button></section>
    </div>
  );
}
